import React from 'react';
import ReactDOM from 'react-dom';
import { ChakraProvider } from '@chakra-ui/react';
import Login from "./pages/login&signup/signin";
import SignUp from "./pages/login&signup/signup";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Home from './pages/Home';
import ErrorPage from './pages/Error'; // Renamed to avoid potential conflicts
import Products from "./pages/products/Products";
import { Provider } from 'react-redux';
import { persistore, store } from './store/index';
import { PersistGate } from 'redux-persist/integration/react';
import Cart from './pages/cart-payment/Cart';
import Payment from './pages/cart-payment/Payment';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home/>,
    errorElement: <ErrorPage/> // Updated to ErrorPage component
  },
  {
    path: "/signin",
    element: <Login/>,
    errorElement: <ErrorPage/> // Updated to ErrorPage component
  },
  {
    path: "/signup",
    element: <SignUp/>
  },
  {
    path: "/products",
    element: <Products/>
  },
  {
    path: "/cart",
    element: <Cart/>
  },
  {
    path: "/payment",
    element: <Payment/>
  },
]);

const root = document.getElementById('root');
ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider>
      <Provider store={store}>
        <PersistGate persistor={persistore}>
          <RouterProvider store={store} router={router} />
        </PersistGate>
      </Provider>
    </ChakraProvider>
  </React.StrictMode>,
  root
);
